module.exports = __webpack_public_path__ + "static/media/shadow-words-corruption.603c5eec.png";